import type { ReactElement } from "react";
import { EINSTELLUNGS_GRUPPEN } from "./Einstellungen.js";
import type { EinstellungsGruppe } from "./Einstellungen.js";
import { Menueeintrag } from "@kundeninfo/ui/me-design";
import { Navigationsleiste } from "../components/meHuellen.js";
import "./EinstellungenSpalte.css";

/**
 * Das Untermenü der Einstellungsgruppen — in der SPALTE des Rahmens (Bereichs-Spalten,
 * Etappe 3).
 *
 * Bis hierher waren die Einstellungen der letzte Bereich neben den Schnittstellen, der ohne
 * Spalte in voller Breite stand: eine Seite mit drei untereinander gestapelten `fieldset`.
 * Das fiel aus der Reihe, seit jeder andere Bereich links seine Liste bzw. sein Untermenü
 * trägt. Etappe 3 gleicht das an — und NUR das: Es kommt keine Einstellung hinzu, keine
 * verschwindet, keine ändert ihr Verhalten.
 *
 * Gezeichnet wird ausschliesslich aus `EINSTELLUNGS_GRUPPEN` (views/Einstellungen.tsx): Die
 * Tabelle bleibt die EINE Quelle (der Router liest sie ebenso), und eine neue Gruppe stünde
 * ohne Zutun in der Spalte — sie ist die einzige Navigation zu ihr.
 *
 * Die Optik folgt dem Bereichs-Untermenü der Verwaltung (views/VerwaltungsSpalte.tsx), der
 * CSS-BLOCK aber nicht: `esp` gehört allein dieser Ansicht (Hausregel „CSS-Blocknamen je
 * Ansicht getrennt"). Eine zweite Ebene gibt es hier nicht — eine Einstellungsgruppe hat
 * keine Objekte.
 */
export type EinstellungenSpalteProps = {
  /** Die offene Gruppe — `null` heisst „noch keine gewählt" (Adresse `/einstellungen`). */
  gruppe: EinstellungsGruppe | null;
  onGruppe: (g: EinstellungsGruppe) => void;
};

export function EinstellungenSpalte(p: EinstellungenSpalteProps): ReactElement {
  // Seit ME-Etappe 4 (P17, Entscheid 44): `me-seitenleiste` mit `me-menueeintrag` statt
  // eigener Knöpfe mit aria-current (Übergang P6-4).
  return (
    <div className="esp">
      <Navigationsleiste name="Einstellungsgruppen">
        {EINSTELLUNGS_GRUPPEN.map((g) => (
          <Menueeintrag key={g.id} className="esp__eintrag" aktuell={g.id === p.gruppe}
            /* Auch die aktive Gruppe meldet: Auf dem iPhone steht die Spalte VOR dem
               Inhalt (siehe spalteZuerst in App.tsx) — ein Antippen ist dort der Weg
               zurück in die offene Gruppe, nicht eine Wiederholung ohne Wirkung
               (dieselbe Regel wie im Untermenü der Verwaltung). */
            onGewaehlt={() => p.onGruppe(g.id)}>
            {g.label}
          </Menueeintrag>
        ))}
      </Navigationsleiste>
    </div>
  );
}
